/* jshint esversion: 6 */
import GtmService from '../gtm/gtm.service';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

const IS_DEV = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '0.0.0.0');
const BASEPATH = (window.location.hostname === '0.0.0.0' ? './img/store-locator/' : '/client/docs/img/store-locator/');

const GTM_CAT = 'store-locator';
const ZOOM_LEVEL = 13;
const SHOW_INFO_WINDOW = false;
const MAX_DISTANCE = 1000;
let GOOGLE_MAPS = null;



export const ITEMS_PER_PAGE = 6;

class StoreLocatorCtrl {

	constructor(
		$scope,
		$timeout,
		DomService,
		ApiService
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.domService = DomService;
		this.apiService = ApiService;
		if (!window.storeLocatorSettings.apiKey && !IS_DEV) {
			throw (`Missing Google Map Api Key`);
		}
		this.apiKey = window.storeLocatorSettings.apiKey;
		this.model = {};
		this.busyFind = false;
		this.busyLocation = false;
		this.busyCity = false;
		this.busyInfoAgents = false;
		this.requiredAddress = false;
		//this.$timeout(() => {
		//	angular.element('#address-input').addClass('disabled');
		//	angular.element('#address-input input').attr('disabled', true);
		//	angular.element('#address-input input').attr('readonly', true);
		//}, 500);
		this.maxSearch = -1;
		this.countSearch = 0;
		this.searchCountry = "";
		this.visibleStores = [];
		this.visibleAgents = [];
		this.searchProvinceCode = "";
		this.searchCity = "";
		this.searchArea = "";
		this.mapCenter$ = new Subject();
		this.labels = window.labels || {
			approximately: window.storeLocatorSettings.localizedStrings.LBL_DISTANZA_STORE,
			moreInfo: `More Info`,
			reachStore: window.storeLocatorSettings.localizedStrings.LBL_RAGGIUNGERE_STORE,
			contactStore: window.storeLocatorSettings.localizedStrings.LBL_CONTATTA_STORE,
			contactAgent: window.storeLocatorSettings.localizedStrings.LBL_CONTATTA_AGENTE
		};
		if (GOOGLE_MAPS !== null) {
			this.initMap();
		} else {
			window.onGoogleMapsLoaded = () => {
				GOOGLE_MAPS = google.maps;
				this.initMap();
			};
			const script = document.createElement('script');
			script.setAttribute('type', 'text/javascript');
			script.setAttribute('src', `https://maps.googleapis.com/maps/api/js?callback=onGoogleMapsLoaded${this.apiKey ? `&key=${this.apiKey}` : ''}&libraries=places&language=${$('html').attr('lang')}`);
			(document.getElementsByTagName('head')[0] || document.documentElement).appendChild(script);
		}

		this.unsubscribe = new Subject();
		this.mapCenter$.pipe(
			debounceTime(1000),
			takeUntil(this.unsubscribe)
		).subscribe(position => {
			this.$timeout(() => {
				this.visibleStores = this.getStoresByViewport();
			}, 1);
		});
		$scope.$on('destroy', () => {
			this.unsubscribe.next();
			this.unsubscribe.complete();
		});
	}

	initMap() {
		const mapOptions = {
			zoom: 17,
			center: new google.maps.LatLng(44.5416713, 10.8259022), // prima ricerca vicino a casa madre
			styles: [
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e9e9e9"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 18
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dedede"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#333333"
						},
						{
							"lightness": 40
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f2f2f2"
						},
						{
							"lightness": 19
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						}
					]
				}
			]
		};
		const mapElement = document.getElementById('map');
		if (!mapElement) {
			return;
		}
		const map = new google.maps.Map(mapElement, mapOptions);

		var startingMapBounds;

		if (window.storeLocatorSettings.currMkt === 2) { // Centramento Italia
			startingMapBounds = this.getItalyBounds();
		} else if (window.storeLocatorSettings.currMkt === 6) { // Centramento Francia
			startingMapBounds = this.getFranceBounds();
		} else {
			startingMapBounds = this.getWorldBounds();
		}

		map.fitBounds(startingMapBounds);

		map.addListener('bounds_changed', () => {
			const position = map.getCenter();
			this.mapCenter$.next(position);
			this.visibleItems = this.getStoresByViewport();
		});

		this.position = mapOptions.center;
		this.$timeout(() => {
			this.map = map;
			window.gmap = map;
		});

		let autocompleteUnique = new google.maps.places.Autocomplete(document.querySelector('#cities-input input'));
		document.querySelector('#cities-input input').addEventListener('keydown', (e) => {
			this.model.address = undefined;
			this.busyCity = false;
		}, false);
		google.maps.event.addListener(autocompleteUnique, 'place_changed', () => {
			var city = autocompleteUnique.getPlace();
			var filteredInfoCity = [];
			if (city.address_components !== undefined) {
				filteredInfoCity = city.address_components.filter(function (address_component) {
					return address_component.types.includes("country");
				});
			}

			// per l'Italia controllo se c'è il dato che serve a me tra i livelli (indirizzo con almeno la via
			// se poi non lo trovo faccio lo show del messaggio per richiedere anche l'indirizzo, nel caso italiano
			var country = filteredInfoCity.length ? filteredInfoCity[0].short_name : '';
			this.requiredAddress = country === 'IT' ? true : false;
			if (this.requiredAddress) {
				var address = [];
				if (city.address_components !== undefined) {
					address = city.address_components.filter(function (address_component) {
						return address_component.types.includes("route");
					});
				}

				if (address.length !== 0) {
					this.model.address = angular.element('#cities-input input').val();
					$("#errorNotes").hide();
				}
				else {
					//$("#errorNotes").html('*Complete address is required for this country!');
					$("#errorNotes").show();
				}
			}
			//if (country === 'IT') {
			//	this.model.address = city.formatted_address;
			//}
			this.busyCity = true;
		});
		document.querySelector('#cities-input input').addEventListener('blur', () => {
			const geocoder = this.geocoder || new google.maps.Geocoder();
			this.geocoder = geocoder;
			geocoder.geocode({ address: this.model.city }, (results, status) => {
				if (status == 'OK') {
					var filteredInfoCity = results[0].address_components.filter(function (address_component) {
						return address_component.types.includes("country");
					});

					var country = filteredInfoCity.length ? filteredInfoCity[0].short_name : '';
					this.requiredAddress = country === 'IT' ? true : false;
					if (this.requiredAddress) {
						var city = autocompleteUnique.getPlace();
						var address = [];
						if (city.address_components !== undefined) {
							address = city.address_components.filter(function (address_component) {
								return address_component.types.includes("route");
							});
						}

						if (address.length !== 0) {
							this.model.address = angular.element('#cities-input input').val();
							$("#errorNotes").hide();
						}
						else {
							//$("#errorNotes").html('*Complete address is required for this country!');
							$("#errorNotes").show();
						}
					}
					this.busyCity = true;
					this.$scope.$apply();
				}
			});
		});

		this.loadAllStores();
		this.loadAllAgents();


	}

	calculateDistance(lat1, lon1, lat2, lon2, unit) {
		if ((lat1 == lat2) && (lon1 == lon2)) {
			return 0;
		} else {
			const radlat1 = Math.PI * lat1 / 180;
			const radlat2 = Math.PI * lat2 / 180;
			const theta = lon1 - lon2;
			const radtheta = Math.PI * theta / 180;
			let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			if (dist > 1) {
				dist = 1;
			}
			dist = Math.acos(dist);
			dist = dist * 180 / Math.PI;
			dist = dist * 60 * 1.1515;
			if (unit == "K") {
				dist = dist * 1.609344;
			}
			if (unit == "N") {
				dist = dist * 0.8684;
			}
			return dist;
		}
	}

	clearMarkers() {
		if (this.markerCluster) {
			this.markerCluster.clearMarkers();
		}

		for (let i = 0; i < this.stores.length; i++) {
			if (this.stores[i].marker) {
				this.stores[i].marker.setMap(null);
				this.stores[i].marker = null;
			}
		}

		if (this.markerAgentCluster) {
			this.markerAgentCluster.clearMarkers();
		}

		for (let i = 0; i < this.agents.length; i++) {
			if (this.agents[i].marker) {
				this.agents[i].marker.setMap(null);
				this.agents[i].marker = null;
			}
		}
	}

	addMarkers(stores) {
		const markers = stores.map((store) => {

			var nomeContenutoGA4 = store.title;
			if (window.data.province && !window.data.searchByTextBox)
				nomeContenutoGA4 = nomeContenutoGA4 + "_" + window.data.provinciaGA4;

			const position = new google.maps.LatLng(store.latitude, store.longitude);
			let content = `<div class="marker__content">
				<div class="title"><span>${store.title}</span></div>
				<div class="group group--info">
					<div class="address">
						${store.address}<br>
						${store.zip} ${store.city} ${store.provinceCode} ${store.countryCode}<br>
						${store.telephone ? `<span class="dtEventSend" gtm data-gtm-eventname="store_locator_interactions" data-gtm-position="map" data-gtm-label="get_call" data-gtm-nomecontenuto="${store.title}"><a href="tel:${store.telephone}">${store.telephone}</a><br></span>` : ''}
						${store.website ? `<span><a target="_blank" href="${store.website}">${store.website}</a></span>` : ''}
					</div>
					${store.address !== '' ? `<div class="distance">${this.labels.approximately} <b>${Math.floor(store.distance)} km</b></div>` : ``}
				</div>
				<div class="group group--cta">
					${store.address !== '' ? `<a  id="locator-marker" href="https://www.google.it/maps/dir/${position.lat()},${position.lng()}/${store.title}/@${store.latitude},${store.longitude}/" target="_blank" class="btn btn--link dtEventSend" gtm data-gtm-eventname="store_locator_interactions" data-gtm-position="map" data-gtm-label="get_direction" data-gtm-nomecontenuto="${store.title}"><span>${this.labels.reachStore}</span></a>` : ``}

					${store.type === 8 || store.type === 9 ? `<a id="contact-store" href="${window.storeLocatorSettings.urlStoreContact}?store=${store.id}" target="_blank" class="btn btn--link dtEventSend" gtm data-gtm-eventname="store_locator_interactions" data-gtm-position="map" data-gtm-label="contact_store" data-gtm-nomecontenuto=` + nomeContenutoGA4 + `><span>${this.labels.contactStore}</span></a>` : ''}
				</div>
			</div>`;

			const icon = ['pin-showroom.png', 'pin-top-store.png', 'pin-reseller.png'][store.type - 8];

			let marker = new google.maps.Marker({
				position: position,
				// map: this.map,
				icon: `${BASEPATH}${icon}`,
				title: store.title,
				store: store,
				content: content,
			});
			marker.addListener('click', () => {
				this.setMarkerWindow(marker.position, content);
				this.scrollToStore(store);
				// GtmService.push({ event: 'dealerlocator', action: 'marker-click', label: store.title });
			});
			store.marker = marker;
			return marker;
		});

		const markerCluster = new MarkerClusterer(this.map, markers, {
			imagePath: `${BASEPATH}cluster-`,
		});
		const styles = markerCluster.getStyles();
		styles.forEach(style => style.textColor = '#ffffff');
		markerCluster.setStyles(styles);
		this.markers = markers;
		this.markerCluster = markerCluster;
	}

	addAgentsMarkers(agents) {
		const markers = agents.map((agent) => {
			//console.log('agent.latitude ', agent.latitude, ' agent.longitude ', agent.longitude, ' this.position.lat() ', this.position.lat(), ' this.position.lng() ', this.position.lng());
			const position = new google.maps.LatLng(agent.latitude === null ? this.position.lat() : agent.latitude, agent.longitude === null ? this.position.lng() : agent.longitude);
			let content = `<div class="marker__content">
				<div class="title"><span>${agent.title}</span></div>
				<div class="group group--info">
					<div class="address">
						${agent.address ? `${agent.address}` : ''}<br>
						${agent.zip ? `${agent.zip}` : ''} ${agent.city ? `${agent.city}` : ''} ${agent.province ? `${agent.province}` : ''} ${agent.countries}<br>
						${agent.telephone ? `<span class="dtEventSend" gtm data-gtm-eventname="store_locator_interactions" data-gtm-position="map" data-gtm-label="get_call" data-gtm-nomecontenuto="${store.title}"><a href="tel:${agent.telephone}">${agent.telephone}</a><br></span>` : ''}
					</div>
				</div>
				<div class="group group--cta">
					<a id="contact-store" href="${window.storeLocatorSettings.urlStoreContact}?agent=${agent.id}" target="_blank" class="btn btn--link"><span>${this.labels.contactAgent}</span></a>
				</div>
			</div>`;

			const icon = 'pin-reseller.png';

			let marker = new google.maps.Marker({
				position: position,
				// map: this.map,
				icon: `${BASEPATH}${icon}`,
				title: agent.title,
				store: agent,
				content: content,
			});
			marker.addListener('click', () => {
				this.setMarkerWindow(marker.position, content);
				//this.scrollToStore(store);
				// GtmService.push({ event: 'dealerlocator', action: 'marker-click', label: store.title });
			});
			agent.marker = marker;
			return marker;
		});

		const markerCluster = new MarkerClusterer(this.map, markers, {
			imagePath: `${BASEPATH}cluster-`,
		});
		const styles = markerCluster.getStyles();
		styles.forEach(style => style.textColor = '#ffffff');
		markerCluster.setStyles(styles);
		this.markers = markers;
		this.markerAgentCluster = markerCluster;
	}

	getGeolocation(map) {
		this.error = null;
		this.busyLocation = true;
		let position = this.map.getCenter();

		// Try HTML5 geolocation.
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition((location) => {
				position = new google.maps.LatLng(location.coords.latitude, location.coords.longitude);

				const geocoder = this.geocoder || new google.maps.Geocoder();
				this.geocoder = geocoder;
				geocoder.geocode({ 'location': position }, (results, status) => {
					if (status == 'OK') {
						var filteredInfoCity = results.filter(function (address_component) {
							return address_component.types.includes("locality");
						});
						this.model.city = filteredInfoCity.length ? filteredInfoCity[0].formatted_address : undefined;
						this.model.address = results[0].formatted_address;

						for (let i = 0; i < results[0].address_components.length; i++) {
							if (results[0].address_components[i].types[0] == "country" || results[0].address_components[i].types[0] == "political") {
								this.searchCountry = results[0].address_components[i].short_name;
							}
						}

						this.setInfoWindow(position, 1);
						this.searchPosition(position).finally(() => this.busyLocation = false);
						this.map.setCenter(position);
						this.map.setZoom(ZOOM_LEVEL);
					}
				});
			}, () => {
				this.setInfoWindow(position, 2);
				this.searchPosition(position).finally(() => this.busyLocation = false);
			});
		} else {
			// Browser doesn't support Geolocation
			this.setInfoWindow(position, 3);
			this.searchPosition(position).finally(() => this.busyLocation = false);
		}
	}

	loadAllStores() {
		//if (this.stores) {
		//	return Promise.resolve(this.stores);
		//}
		// this.loadFakeStores();
		const isStatic = false;
		return this.apiService.storeLocator.all(isStatic).then(success => {
			const stores = success.data.d.storeList; //success.data; // success.data.d.storeList;
			stores.forEach(store => store.distance = this.position ? this.calculateDistance(store.latitude, store.longitude, this.position.lat(), this.position.lng(), 'K') : '');

			this.visibleItems = [];
			this.maxItems = ITEMS_PER_PAGE;
			this.stores = stores;
			this.visibleItems = this.getStoresByViewport();

			return stores;
		});
	}

	loadAllAgents() {
		this.agents = [];
		return this.agents;
		if (this.agents) {
			return Promise.resolve(this.agents);
		}
		const isStatic = false;
		return this.apiService.agentLocator.all().then(success => {
			const agents = success.data.d.agentList;

			this.agents = agents;

			return agents;
		});
	}

	loadFakeStores() {
		return fetch(`https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input=Ceramiche&inputtype=textquery&fields=name,formatted_address,address_components,formatted_phone_number,geometry${this.apiKey ? `&key=${this.apiKey}` : ''}`, { mode: 'cors' }).then(response => {
			return response.json();
		}).then(json => {
			console.log('json', json);
			return json.candidates.map((x, i) => {
				return {
					id: i + 1,
					latitude: x.geometry.location.lat,
					longitude: x.geometry.location.lng,
					title: x.name,
					address: x.formatted_address,
					type: 1 + Math.floor(Math.random() * 3)
				}
			});
			/*
			{
				id: 2,
				latitude: 44.5902807,
				longitude: 10.721454,
				title: 'Lea Ceramiche',
				abstract: 'Negozio di piastrelle ceramiche',
				address: 'Via Statale, 127',
				zip: '42013',
				city: 'Casalgrande',
				province: 'Reggio Emilia',
				provinceCode: 'RE',
				country: 'Italia',
				countryCode: 'IT',
				telephone: '+39 0536 837811',
				email: 'info@ceramichelea.it',
				website: 'https://www.ceramichelea.it/',
				image: './img/store-locator/02@2x.jpg',
				type: 3
			}
			*/
		});
	}

	fitBounds(stores) {
		if (stores.length) {
			const bounds = new google.maps.LatLngBounds();
			stores.forEach((store) => {
				const position = new google.maps.LatLng(store.latitude, store.longitude);
				bounds.extend(position);
			});
			this.map.fitBounds(bounds);
			// console.log('fitBounds');
		}
	}

	findNearStores(stores, position) {
		if (stores) {
			stores.forEach((store) => {
				store.distance = this.calculateDistance(store.latitude, store.longitude, position.lat(), position.lng(), 'K');
				store.visible = (store.cod_stato == window.userCountry || !window.userCountry) && store.distance <= MAX_DISTANCE /* Km */;
				if (store.visible) {
					if (store.removed) this.markerCluster.addMarker(store.marker);
					delete store.removed;
				} else {
					this.markerCluster.removeMarker(store.marker);
					store.removed = true;
				}
			});
			stores = stores.slice();
			stores.sort((a, b) => {
				//return a.distance * (a.importante ? 0.5 : 1) - b.distance * (b.importante ? 0.5 : 1);
				return a.distance - b.distance;
			});
			const visibleStores = stores.filter(store => store.visible).slice(0, 50);
			this.$timeout(() => {
				this.visibleStores = visibleStores;
			}, 1);
			// console.log('findNearStores', visibleStores);
			return visibleStores;
		}
	}

	searchPosition(position, viewport) {
		this.position = position;
		this.viewport = viewport;
		this.map.setCenter(position);
		this.map.setZoom(ZOOM_LEVEL);
		this.setInfoWindow(position, 1);

		return this.loadAllStores().then(success => {
			this.clearMarkers();
			this.closeMarkerWindow();

			this.stores.forEach(store => store.distance = this.position ? this.calculateDistance(store.latitude, store.longitude, this.position.lat(), this.position.lng(), 'K') : '');
			this.stores = this.stores.sort((a, b) => {
				if (a.type === b.type) {
					return a.distance - b.distance;
				} else {
					return a.type - b.type;
				}
			});

			// if (continentAmerica[this.searchCountry] === undefined) {
			// 	//Ricerca negli altri continenti
			// 	if (this.countryContainsStores(this.searchCountry)) {
			// 		//console.log('#1');
			// 		// Vengono aggiunti solo i marker del paese ricercato.
			// 		var storesByCountry = this.getStoresByCountry(this.searchCountry);
			// 		//console.log('storesByCountry ', storesByCountry);
			// 		if (storesByCountry.length > 6) {
			// 			storesByCountry = storesByCountry.sort((a, b) => {
			// 				return a.distance - b.distance;
			// 			});
			// 			storesByCountry = storesByCountry.filter(function (store) {
			// 				//console.log('store ', store);
			// 				return store.distance <= 150;
			// 			}).slice(0, 6);
			// 		}
			// 		this.addMarkers(storesByCountry);

			// 		// 2a. Cerco i pin in un raggio di 50Km, eventualmente lo estendo se non c'è nulla.
			// 		for (let searchRadius = 50000; searchRadius <= 600000; searchRadius += 50000) {
			// 			var searchBounds = new google.maps.Circle({ center: position, radius: searchRadius }).getBounds();

			// 			if (this.boundsContainsStores(searchBounds)) {
			// 				break;
			// 			}
			// 		}
			// 		if (searchBounds) {
			// 			//console.log('this.searchCountry ', this.searchCountry, ' searchBounds ', searchBounds, ' this.viewport ', this.viewport);
			// 			if (storesByCountry.length === 1 && this.searchCountry !== 'AU') {
			// 				//console.log('#1.1');
			// 				this.map.fitBounds(this.viewport);
			// 				this.map.setZoom(6);
			// 			} else {
			// 				//console.log('#1.2');
			// 				if (this.searchCountry === 'AU') {
			// 					const geocoder = this.geocoder || new google.maps.Geocoder();
			// 					this.geocoder = geocoder;
			// 					geocoder.geocode({ address: 'Australia' }, (results, status) => {
			// 						if (status == 'OK') {
			// 							const viewportUS = results[0].geometry.viewport;
			// 							this.map.fitBounds(viewportUS);
			// 						}
			// 					});
			// 				} else {
			// 					this.map.fitBounds(searchBounds, 0);
			// 				}
			// 				this.map.fitBounds(searchBounds, 0);
			// 			}
			// 			this.map.panToBounds(searchBounds);
			// 		}
			// 	} else {
			// 		//console.log('#2');
			// 		// Se non ci sono store nel paese ricercato allora mostro il mondo intero e il PIN Showroom Italia.
			// 		let italyMainStore = this.stores[1];
			// 		this.addMarkers([italyMainStore]);

			// 		this.map.fitBounds(this.getWorldBounds());
			// 		this.map.panTo(new google.maps.LatLng(italyMainStore.latitude, italyMainStore.longitude));
			// 		this.setMarkerWindow(italyMainStore.marker.position, italyMainStore.marker.content);
			// 	}
			// } else {
			// 	//console.log('#3');
			// 	//Ricerca nel continente americano
			// 	let USAMainStore = this.stores[0];
			// 	this.addMarkers([USAMainStore]);

			// 	this.map.fitBounds(this.getWorldBounds());
			// 	this.map.panTo(new google.maps.LatLng(USAMainStore.latitude, USAMainStore.longitude));
			// 	this.setMarkerWindow(USAMainStore.marker.position, USAMainStore.marker.content);
			// }

			// const visibleStores = this.findNearStores(stores, position);
			/*
			if (visibleStores) {
				this.fitBounds(visibleStores);
			}
			*/
		});
	}

	panTo(store) {
		const position = new google.maps.LatLng(store.latitude, store.longitude);
		this.map.setZoom(ZOOM_LEVEL);
		this.map.panTo(position);
		const marker = this.markers.find(x => x.store === store);
		this.setMarkerWindow(marker.position, marker.content);
	}

	onSubmit() {
		var target = document.getElementById("results");
		target.scrollIntoView({ behavior: "smooth", block: "start" });
		this.$timeout(() => {
			if (this.busyCity) {
				this.error = null;
				this.busyFind = true;
				/*
				const fakeFilter = {
					'': {
						value: this.model.address,
						options: [
							{
								value: this.model.address,
								key: this.model.address
							}
						]
					}
				};
				GtmService.pageViewFilters(GTM_CAT, fakeFilter);
				*/
				const geocoder = this.geocoder || new google.maps.Geocoder();
				this.geocoder = geocoder;
				geocoder.geocode({ address: this.requiredAddress ? this.model.address : this.model.city }, (results, status) => {
					this.model = {
						city: this.model.city,
						address: this.model.address
					};
					if (status == 'OK') {
						const position = results[0].geometry.location;
						const viewport = results[0].geometry.viewport;
						console.log('results ', results);
						for (let i = 0; i < results[0].address_components.length; i++) {
							if (results[0].address_components[i].types[0] == "country" || results[0].address_components[i].types[0] == "political") {
								this.searchCountry = results[0].address_components[i].short_name;
							}
						}

						for (let i = 0; i < results[0].address_components.length; i++) {
							if (results[0].address_components[i].types[0] == "administrative_area_level_2") {
								this.searchProvinceCode = results[0].address_components[i].short_name;
							}
						}
						for (let i = 0; i < results[0].address_components.length; i++) {
							if (results[0].address_components[i].types[0] == "administrative_area_level_3" || results[0].address_components[i].types[0] == "locality") {
								this.searchCity = results[0].address_components[i].short_name;
							}
						}
						for (let i = 0; i < results[0].address_components.length; i++) {
							if (results[0].address_components[i].types[0] == "administrative_area_level_1") {
								this.searchArea = results[0].address_components[i].short_name;
							}
						}
						//console.log('this.searchProvinceCode ', this.searchProvinceCode, ' this.searchCity ', this.searchCity);

						const obj = Object.assign({}, window.objDataLayerInfo);
						obj["eventname"] = "store_locator_search";
						obj["searchterm"] = results.length > 0 ? results[0].formatted_address : "";
						GtmService.push(obj);

						// console.log('location', location);
						// const position = new google.maps.LatLng(location);
						this.searchPosition(position, viewport).finally(() => this.busyFind = false, this.model.address = this.model.address, this.countSearch++);
					} else {
						this.$timeout(() => {
							const message = 'Geocode was not successful for the following reason: ' + status;
							// console.log('StoreLocatorCtrl.onSubmit.error', message);
							this.error = { message };
							this.busyFind = false;
						});
					}
				});
			}
		}, 500);
	}

	setInfoWindow(position, mode) {
		if (SHOW_INFO_WINDOW) {
			const infoWindow = this.infoWindow || new google.maps.InfoWindow();
			this.infoWindow = infoWindow;
			infoWindow.setPosition(position);
			switch (mode) {
				case 1:
					infoWindow.setContent('Current location');
					break;
				case 2:
					infoWindow.setContent('Error: The Geolocation service failed.');
					break;
				default:
					infoWindow.setContent('Error: Your browser doesn\'t support geolocation.');
			}
			infoWindow.open(this.map);
		}
	}

	setMarkerWindow(position, content) {
		if (position) {
			const markerWindow = this.markerWindow || new google.maps.InfoWindow({
				pixelOffset: new google.maps.Size(0, -35)
			});
			this.markerWindow = markerWindow;
			markerWindow.setPosition(position);
			markerWindow.setContent(content);
			markerWindow.open(this.map);
		} else {
			this.closeMarkerWindow();
		}
	}

	closeMarkerWindow() {
		if (this.markerWindow) {
			this.markerWindow.close();
		}
	}

	getWorldBounds() {
		return new google.maps.LatLngBounds(
			new google.maps.LatLng(61, 60),
			new google.maps.LatLng(-37, -92)
		);
	}

	getItalyBounds() {
		return new google.maps.LatLngBounds(
			new google.maps.LatLng(46.4657567, 5.233972),
			new google.maps.LatLng(36.8257773, 18.963541)
		);
	}

	getFranceBounds() {
		return new google.maps.LatLngBounds(
			new google.maps.LatLng(51.15040672463023, -5.271186534462046),
			new google.maps.LatLng(42.191156239056426, 7.84728980702387)
		);
	}

	scrollToStore(store) {
		const storesNode = document.querySelector('.section--stores');
		const storeNode = document.querySelector(`#store-${store.id}`);
		// console.log(storesNode, storeNode);
		storesNode.scrollTo(0, storeNode.offsetTop);
	}

	onScroll(event) {
		if (this.visibleItems && this.visibleItems.length !== this.maxItems) {
			if (event.rect.top + event.rect.height < event.windowRect.bottom) {
				if (!this.busy && this.maxItems < this.stores?.length) {
					this.$timeout(() => {
						this.busy = true;
						this.$timeout(() => {
							this.maxItems += ITEMS_PER_PAGE;
							this.visibleItems = this.getStoresByViewport();
							this.busy = false;
							console.log(this.visibleItems.length);
						}, 1000);
					}, 0);
				}
			}
		}
	}

	getStoresByCountry(countryCode) {
		let stores = [];

		if (this.stores) {
			for (let i = 0; i < this.stores.length; i++) {
				if (this.stores[i].countryCode === countryCode) {
					stores.push(this.stores[i]);
				}
			}
		}

		return stores;
	}

	getAgentsByInfo(countryCode) {
		let agents = [];
		let provinceCode = this.searchProvinceCode !== '' ? this.searchProvinceCode : this.stores.length > 0 && this.stores[1].province ? this.stores[1].province : ''; // level_2 - provincia
		let cityCode = this.searchCity !== '' ? this.searchCity : this.stores.length > 0 && this.stores[1].city ? this.stores[1].city : ''; // level_3 - città
		let areaCode = this.searchArea !== '' ? this.searchArea : this.stores.length > 0 && this.stores[1].city ? this.stores[1].city : ''; // level_1 - area
		if (countryCode !== '') {
			if (countryCode === 'IT' || countryCode === 'FR' || countryCode === 'DE') {
				//facendo così, mentre per l'Italia riceviamo un provinceCode del tipo 'RM' (indipendente dalla lingua), per la Francia ci viene restituito 'Parigi' o 'Paris'
				//a seconda della lingua quindi per trovare il match dobbiamo registrare più "coperture" per gli agenti, in tutte le lingue
				agents = _.filter(this.agents, function (o) {
					return o.countries_detail !== null &&
						o.countries_detail.indexOf(countryCode) !== -1 &&
						(
							(o.administrative_area_level_2_detail !== null &&
								o.administrative_area_level_2_detail.map(function (el) {
									return el.trim();
								}).indexOf(provinceCode.trim()) !== -1
							) ||
							// controllo anche se google mi ha passato l'informazione che cerco (copertura agente administrative_level_2)
							// in un altro campo: administrative_level_1, administrative_level_3... Fondamentale per la Germania!
							(o.administrative_area_level_2_detail !== null &&
								o.administrative_area_level_2_detail.map(function (el) {
									return el.trim();
								}).indexOf(cityCode.trim()) !== -1
							) ||
							(o.administrative_area_level_2_detail !== null &&
								o.administrative_area_level_2_detail.map(function (el) {
									return el.trim();
								}).indexOf(areaCode.trim()) !== -1
							)
						)
						;
				});
			}
			else {
				agents = _.filter(this.agents, function (o) {
					return o.countries_detail !== null &&
						o.countries_detail.indexOf(countryCode) !== -1;
				});
			}
		}
		//non mettiamo il market per l'agente
		//agents.forEach((agent) => {
		//	const geocoder = this.geocoder || new google.maps.Geocoder();
		//	this.geocoder = geocoder;
		//	geocoder.geocode({ address: agent.administrative_area_level_1 }, (results, status) => {
		//		if (status == 'OK') {
		//			agent.latitude = results[0].geometry.location.lat();
		//			agent.longitude = results[0].geometry.location.lng();
		//		} else {
		//			agent.latitude = null;
		//			agent.longitude = null;
		//		}
		//	});
		//});
		agents = _.sortBy(agents, o => o.order);
		return agents;
	}

	countryContainsStores(countryCode) {
		if (this.stores) {
			for (let i = 0; i < this.stores.length; i++) {
				if (this.stores[i].countryCode === countryCode) {
					return true;
				}
			}
		}

		return false;
	}

	boundsContainsStores(bounds) {
		if (this.stores) {
			for (let i = 0; i < this.stores.length; i++) {
				if (this.stores[i].marker && bounds.contains(this.stores[i].marker.getPosition())) {
					return true;
				}
			}
		}

		return false;
	}

	getStoresByViewport() {
		let visibleItems = [];

		if (this.stores) {
			for (let i = 0; i < this.stores.length; i++) {
				if (this.stores[i].marker && this.map.getBounds().contains(this.stores[i].marker.getPosition())) {
					visibleItems.push(this.stores[i]);
				}
			}
		}

		visibleItems = visibleItems.sort((a, b) => {
			//if (a.type === b.type) {
			return a.distance - b.distance;
			//} else {
			//	return a.type - b.type;
			//}
		});

		return visibleItems; //.slice(0, 3);
	}

}

StoreLocatorCtrl.$inject = ['$scope', '$timeout', 'DomService', 'ApiService'];

export default StoreLocatorCtrl;
